// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1__fea75af8707f22afb941","cls2":"SmallAccountMenuButton-cls2___a45b7ee1294d00199b4 SmallAccountMenuButton-cls1__fea75af8707f22afb941"};